import { Outlet } from "react-router-dom";

import cls from "./AuthLayout.module.css";

import { GdprConsentBanner } from "@/widgets/gdprConsent";

export const AuthLayout = () => {
    return (
        <>
            <div className={cls.layout}>
                <Outlet />
            </div>
            <GdprConsentBanner />
        </>
    );
};
